import React from 'react';
import { parseISO, format } from 'date-fns';
import { withStyles } from '@material-ui/core/styles';
import {
  LinearProgress,
  Typography,
  Paper,
  Divider,
  Grid,
  Button
 } from '@material-ui/core';
import classNames from 'classnames';

const TitleImportItem = ({ classes, importItem, handleTitlesRedirect }) => {
  return (
    <div className={classes.itemContainer}>
      <Paper className={classes.paperContainer} elevation={1}>
        <Grid container>
          <div style={{flexGrow: 1}}>
            <Typography className={classNames(classes.successProgressStatus, classes.fontBold)}>Success</Typography>
            <div className={classes.progressHeader}>
              <Typography><span className={classes.fontBold}>Title Import: </span>{`(${importItem.importCount} properties),
                imported on ${format(parseISO(importItem.importedOn), 'MM/dd/yyyy, h:mm:ss a')} by `}<span className={classes.fontBold}>{importItem.importedBy}</span></Typography>
            </div>
          </div>
          <div>
            <Button variant='contained' color='primary' onClick={() => {handleTitlesRedirect(importItem.transactionOpportunityIds)}}>View on Workflow</Button>
          </div>
        </Grid>
        <Divider className={classes.divider}/>
        <div className={classes.progressContainer}>
          <LinearProgress variant="determinate" value={100} />
        </div>
      </Paper>
    </div>
  )
}

const styles = theme => ({
  itemContainer: {
    marginBottom: theme.spacing(1.5),
  },
  paperContainer: {
    padding: theme.spacing(1),
  },
  successProgressStatus: {
    color: '#2196f3',
  },
  progressHeader: {
    display: 'flex',
    alignItems: 'center',
    height: 20
  },
  progressContainer: {
    marginTop: theme.spacing(1)
  },
  fontBold: {
    fontWeight: 'bold',
  },
  divider: {
    margin: `${theme.spacing(0.5)}px 0`
  },
});

export default withStyles(styles)(TitleImportItem);